<script lang="ts">
	import { RadioGroup as RadioGroupPrimitive } from "bits-ui";
	import { cn } from "$lib/utils.js";
    import { setRadioButtonGroupCtx, type RadioButtonVariants } from ".";

	type $$Props = RadioGroupPrimitive.Props & RadioButtonVariants;

	let className: $$Props["class"] = undefined;
    export let variant: $$Props["variant"] = "default";
	export let selectVariant: $$Props["selectVariant"] = "default";
	export let size: $$Props["size"] = "default";
	export let grouped: $$Props["grouped"] = false
	export let value: $$Props["value"] = undefined;
	export { className as class };

    setRadioButtonGroupCtx({
		variant,
		selectVariant,
		size,
		grouped,
	});
</script>

<RadioGroupPrimitive.Root bind:value class={cn("flex", grouped ? "gap-0" : "gap-2", className)} {...$$restProps}>
	<slot />
</RadioGroupPrimitive.Root>
